<h2>Web Verification</h2>

<div>
  To keep your EZLynx account secure, we need to send you a code.
  Please select where you would like to receive the code.
</div>

<div [formGroup]="form">
  <mat-radio-group name="verificationType"
                   class="two-factor-options"
                   formControlName="verificationType">
    @for (option of options; track option) {
      <mat-radio-button id="VerificationType_{{option.verificationType}}"
                        [value]="option.verificationType"
                        [checked]="option.checked">
        {{ option.optionData.display }}
      </mat-radio-button>
    }
  </mat-radio-group>

  @if (!success) {
    <div class="ez-alert warn">
      <mat-icon color="warn">report</mat-icon>

      <div class="alert-text">
        {{ errorMessage }}
      </div>
    </div>
  }

  <div class="two-factor-buttons">
    <a href="../"
       mat-stroked-button
       color="primary"
       id="two-factor-cancel">Cancel</a>

    <button mat-flat-button
            id="two-factor-next"
            type="submit"
            color="primary">Next</button>
  </div>
</div>